import Vue from 'vue'
import Router from 'vue-router'

import LIST from '@/components/list'
import detaill from '@/components/detaill'
import home from '@/ivew/home'
import fengmian from '@/ivew/fengmian'
Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'fengmian',
      component: fengmian
    },
    {
      path: '/LIST',
      name: 'LIST',
      component: LIST
    },
    {
      path: '/home',
      name: 'home',
      component: home,
    },
    {
      path: '/detaill',
      name: 'detaill',
      component: detaill
    }
   
  ],
 // mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js